module.exports = __webpack_public_path__ + "static/media/9DESA16.afd5e2f7.jpg";